const slideData = [
  {
    id: 0,
    title: 'Investor Real Estate Lending',
    text: 'We provide fast, flexible financing for real estate investors nationwide — including fix & flip, rental, and build-to-rent projects.',
    imageClass: 'hero'
  },
  {
    id: 1,
    title: 'Fix & Flip Capital',
    text: 'Short-term financing for value-add properties, covering acquisition and renovation costs with asset-based underwriting and quick closings.'
  },
  {
    id: 2,
    title: 'Rental & DSCR Loans',
    text: 'Long-term rental financing based on property cash flow, ideal for buy-and-hold investors, portfolios, and BRRRR strategies.'
  },
  {
    id: 3,
    title: 'Build & Fix-to-Rent',
    text: 'Construction and transitional financing for investors building or renovating properties to stabilize and hold as rentals.'
  }
];

export default slideData;
